import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * HTTP Interceptor that adds Azure API Management subscription key header
 * to all outgoing HTTP requests when configured.
 */
@Injectable()
export class ApimSubscriptionKeyInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const subscriptionKey = environment.api?.apimSubscriptionKey;

    // Only add header if subscription key is configured
    if (subscriptionKey) {
      request = request.clone({
        setHeaders: {
          'Ocp-Apim-Subscription-Key': subscriptionKey
        }
      });
    }

    return next.handle(request);
  }
}
